// encode
export const encodeDraft = (obj: any): string => {
  const json = JSON.stringify(obj);
  const utf8Bytes = new TextEncoder().encode(json);
  const binaryString = Array.from(utf8Bytes).map(b => String.fromCharCode(b)).join('');
  const base64 = btoa(binaryString);
  return encodeURIComponent(base64);
};

// decode
export const decodeDraft = (encoded: string): any => {
  const base64 = decodeURIComponent(encoded);
  const binaryString = atob(base64);
  const bytes = new Uint8Array(Array.from(binaryString).map(c => c.charCodeAt(0)));
  const json = new TextDecoder().decode(bytes);
  return JSON.parse(json);
};
